<template>
  <VListItem
    class="UserLine"
    two-line
    exact
    :ripple="false"
    :disabled="disabled"
    :to="{ name: 'user', params: { userId } }"
  >
    <VListItemAvatar color="green">
      <strong class="white--text">
        {{ initials }}
      </strong>
    </VListItemAvatar>
    <VListItemContent>
      <VListItemTitle class="black--text">
        {{ displayName }}
      </VListItemTitle>
      <VListItemSubtitle>
        <slot>
          &nbsp;
        </slot>
      </VListItemSubtitle>
    </VListItemContent>
    <template v-if="icon">
      <VTooltip
        v-if="iconTooltip"
        bottom
      >
        <template #activator="{ on }">
          <VListItemAction v-on="on">
            <VBtn
              icon
              :disabled="actionDisabled === null ? disabled : actionDisabled"
              @click.native.prevent.stop="$emit('click:icon')"
            >
              <VIcon
                :color="iconColor"
                v-text="icon"
              />
            </VBtn>
          </VListItemAction>
        </template>
        {{ iconTooltip }}
      </VTooltip>
      <VListItemAction v-else>
        <VBtn
          icon
          :disabled="actionDisabled === null ? disabled : actionDisabled"
          @click.native.prevent.stop="$emit('click:icon')"
        >
          <VIcon
            :color="iconColor"
            v-text="icon"
          />
        </VBtn>
      </VListItemAction>
    </template>
  </VListItem>
</template>

<script>
export default {
  name: 'UserLine',
  props: {
    userId: { type: Number, required: true },
    icon: { type: String, default: null },
    iconColor: { type: String, default: 'grey lighten-1' },
    iconTooltip: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    actionDisabled: { type: Boolean, default: null },
  },
  computed: {
    displayName() {
      const { $store, userId } = this
      return $store.getters['user/displayName'](userId)
    },
    initials() {
      const { $store, userId } = this
      return $store.getters['user/initials'](userId)
    },
  },
}
</script>
